<template>
  <div class="home-wage-view-toggle" role="group" aria-label="급여 표시 시점">
    <button
      type="button"
      class="home-wage-view-toggle__btn"
      :class="{ 'home-wage-view-toggle__btn--active': directorActive }"
      :disabled="disabled"
      @click="emit('select', 'director')"
    >
      센터장
    </button>
    <button
      type="button"
      class="home-wage-view-toggle__btn"
      :class="{ 'home-wage-view-toggle__btn--active': !directorActive }"
      :disabled="disabled"
      @click="emit('select', 'admin')"
    >
      관리자
    </button>
  </div>
</template>

<script setup lang="ts">
withDefaults(
  defineProps<{
    directorActive?: boolean;
    disabled?: boolean;
  }>(),
  {
    directorActive: true,
    disabled: false,
  }
);

const emit = defineEmits<{
  select: ['director' | 'admin'];
}>();
</script>
